module.exports = __webpack_public_path__ + "fonts/Graphik-BoldItalic-Web.deb5b95.woff2";